import React, { useMemo, useEffect, useState } from 'react'
import { Col, Row } from 'react-bootstrap'
import { Image } from 'react-bootstrap'
import axios from 'axios'
import FormGroupPreview from './FormGroupPreview'
import SubmitBtn from './SubmitBtn'
import moment from 'moment'

const DispatchMsg = ({
  match: { params: { bId = null, sId = null } = {} } = {},
  className = '',
  acceptedIcon = '/images/icons/accepted.png',
  expiredIcon = '/images/icons/expired.png',
}) => {
  const [booking, setBooking] = useState()
  const [supplier, setSupplier] = useState()
  const [vehicle, setVehicle] = useState()
  const [image, setImage] = useState()
  const [status, setStatus] = useState()
  const [renderComponent, setRenderComponent] = useState(false)

  setInterval(() => {
    setRenderComponent(true)
  }, 500)

  async function makeGetRequest() {
    const apiResponse = await axios(process.env.REACT_APP_API_URL + '/api/v1/external/fetchToken/' + sId)
    const partnerToken = apiResponse.data.data.partnerToken
    const apiHost = process.env.REACT_APP_API_URL
    const response = await axios(
      process.env.REACT_APP_API_URL + '/api/v1/dispatch/' + bId + '/' + sId
    )
    const bookingId = bId
    if (partnerToken) {
      if (apiHost === 'https://staging.rolzo.com/api') {
        window.location.replace(`https://staging.rolzo.com/partner/driver/app/details/${partnerToken}/${bookingId}`)
      } else if (apiHost === 'https://business.rolzo.com/api') {
        window.location.replace(`https://business.rolzo.com/partner/driver/app/details/${partnerToken}/${bookingId}`)
      } else if (apiHost === 'http://localhost:3000') {
        window.location.replace(`http://localhost:3001/partner/driver/app/details/${partnerToken}/${bookingId}`)
      }
    }
    else {
      const booking = response.data.data.booking
      const supplier = response.data.data.supplier
      const vehicle = response.data.data.vehicle
      const image = response.data.data.image
      const status = response.data.data.supplierStatus
      setStatus(status)
      setBooking(booking)
      setSupplier(supplier)
      setVehicle(vehicle)
      setImage(image)
    }
  }

  useEffect(() => {
    makeGetRequest()
  }, [])

  const getFormattedTripInfo = (tripInfo) => {
    if (!tripInfo) {
      return
    }
    let formattedInfo = {}
    if (!tripInfo.duration) {
      formattedInfo.duration = '0 h 0 min'
    } else {
      const parsedDuration = moment.utc(tripInfo.duration * 1000).format('H:mm')
      const splittedValue = parsedDuration.split(':')
      formattedInfo.duration = `${
        splittedValue[0] !== '0'
          ? `${splittedValue[0]} h ${splittedValue[1]} min`
          : `${splittedValue[1]} min`
      }`
    }

    if (!tripInfo.distance) {
      formattedInfo.distance = tripInfo.unitSystem === 'KM' ? '0 km' : '0 miles'
    } else {
      let value =
        tripInfo.unitSystem === 'KM'
          ? tripInfo.distance / 1000
          : (tripInfo.distance / 1000) * 0.621371
      formattedInfo.distance = `${Math.round(value).toFixed(2)} ${
        tripInfo.unitSystem === 'KM' ? 'km' : 'miles'
      }`
    }
    return formattedInfo
  }

  const VehicleValue = ({ value, icon = 'team' }) => {
    return (
      <span className='vehicle-value'>
        <img src={`/images/icons/${icon}.svg`} alt='' /> {value}
      </span>
    )
  }

  return (
    <div>
      {renderComponent === true ? (
        <div>
          {status === 'accepted' && (
            <>
              <div
                className='dispatch-preview-info'
                style={{ pointerEvents: 'none' }}
              >
                <header className='rolzo-header '>
                  <img src='/images/rolzo_logo_black.png' alt='' />
                </header>
              </div>
              <div className='dispatch-msg-modal success'>
                <div className='dispatch-msg-modal success'>
                  <div className='content-wrap'>
                    <Image src={acceptedIcon} />
                    <h4 className='dispatch-msg-header'>
                      Congratulations, your booking is confirmed
                    </h4>
                    <p className='dispatch-msg-description'>
                      {
                        'We will send you an email to assign the chauffeur \n 24 hours prior to the scheduled pick-up time.'
                      }
                    </p>
                    <a
                      className='dispatch-msg-link'
                      href=''
                      onClick={() =>
                        (window.location = `/dispatch/${bId}/${sId}`)
                      }
                    >
                      View full booking details{' '}
                    </a>
                  </div>
                </div>
              </div>
              <br />
              <br />
              <hr />
              <h6 className='pl-3 pb-3' style={{ fontSize: '15px' }}>
                Contact our Operations team 24/7
              </h6>
              {/* <br /> */}
              <div className='px-3'>
                <div className='d-flex align-items-center pb-2'>
                  <div className=''>
                    <strong>Email | </strong>
                  </div>{' '}
                  <div className='text-brown pl-1'>
                    <a className='text-brown' href='mailto:partners@rolzo.com'>
                      partners@rolzo.com
                    </a>
                  </div>
                </div>
                {/* <br /> */}
                <div className='d-flex align-items-center'>
                  <div>
                    <strong>Americas | </strong>
                  </div>{' '}
                  <div className='text-brown pl-1'>+44 (0) 20 3239 5152</div>
                  <div className='pl-3'>
                    <strong>UK and Europe | </strong>
                  </div>{' '}
                  <div className='text-brown pl-1'>+44 (0) 20 3239 5152</div>
                  <div className='pl-3'>
                    <strong>Middle East | </strong>
                  </div>{' '}
                  <div className='text-brown pl-1'>+44 (0) 20 3239 5152</div>
                  <div className='pl-3'>
                    <strong>Asia | </strong>
                  </div>{' '}
                  <div className='text-brown pl-1'>+44 (0) 20 3239 5152</div>
                </div>
                <hr />
                <div>
                  <p className='copy-text'>
                    {' '}
                    &copy; 2021 ROLZO. All rights reserved.{' '}
                    <span>
                      <a
                        target='_blank'
                        href='https://rolzo.com/terms-conditions'
                      >
                        Terms
                      </a>{' '}
                      |{' '}
                      <a
                        target='_blank'
                        href='https://rolzo.com/privacy-policy'
                      >
                        Privacy
                      </a>{' '}
                    </span>{' '}
                  </p>
                </div>
              </div>
            </>
          )}
          {status === 'expired' && (
            <>
              <div className='dispatch-preview-info'>
                <header className='rolzo-header '>
                  <img src='/images/rolzo_logo_black.png' alt='' />
                </header>
              </div>
              <div className='dispatch-msg-modal-expired'>
                <div className='content-wrap'>
                  <Image src={expiredIcon} />
                  <h4 className='dispatch-msg-header'>Booking expired</h4>
                  <p className='dispatch-msg-description'>
                    {
                      'This offer has been accepted by another \n partner and it is no longer available.'
                    }
                  </p>
                </div>
              </div>
            </>
          )}
          {status === 'dispatched' || status === 'opened' && (
            <div>
              <div className='dispatch-preview-info'>
                <header className='rolzo-header'>
                  <img src='/images/rolzo_logo_black.png' alt='' />
                </header>
                <h6 className='section-header'> New booking </h6>
                <Row>
                  <Col lg='6' className='col-dispatch-detail'>
                    <div className='dispatch-preview-info-section'>
                      <FormGroupPreview
                        label='Booking ID'
                        value={booking.number}
                        addClass='normalizeText'
                      />
                      <Row className='model-row mt-20'>
                        <Col md='6'>
                          {booking.type === 'car_rentals' ? (
                            <FormGroupPreview
                              label='Category'
                              value={vehicle.categorySelfDrive}
                            />
                          ) : (
                            <FormGroupPreview
                              label='Category'
                              value={vehicle.categoryChauffeured}
                            />
                          )}

                          <FormGroupPreview
                            label='MODEL'
                            value={`${vehicle.make} ${vehicle.model}`}
                            className='mt-3 mb-2'
                          />
                          {vehicle.passenger && vehicle.luggage ? (
                            <div className='d-flex align-items-end justify-content-start'>
                              <VehicleValue
                                value={vehicle.passenger}
                                icon='team'
                              />

                              <VehicleValue
                                value={vehicle.luggage}
                                icon='portfolio'
                              />
                            </div>
                          ) : null}
                        </Col>
                        <Col md='6'>
                          <img
                            src={image.image}
                            alt=''
                            className='d-block img-fluid vehicle-img-small'
                          />
                        </Col>
                      </Row>
                      <hr />
                      <FormGroupPreview
                        label='Service Type'
                        value={booking.type.replace('_', ' ')}
                      />
                      <hr />
                      <FormGroupPreview
                        label='Pick up date and time'
                        value={booking.pickUpDateString}
                      />
                      <FormGroupPreview
                        label='Pick up location'
                        value={booking.pickUpLocation.fullAddress}
                      />
                      {booking.type === 'car_rentals' ? (
                        <>
                          <hr />
                          <FormGroupPreview
                            label='Drop off date and time'
                            value='18.09.2021, 8:50'
                          />
                          <FormGroupPreview
                            label='Drop off location'
                            value={booking.dropOffLocation.fullAddress}
                          />
                        </>
                      ) : null}
                      {/* {booking.type !== 'chauffeur_services' ? (
                        <>
                          <FormGroupPreview
                            label='Drop off location'
                            value={booking.dropOffLocation.fullAddress}
                          />
                          <hr />
                        </>
                      ) : null} */}
                      {booking.type !== 'chauffeur_services' &&
                        booking.type !== 'car_rentals' && (
                          <>
                            <hr />
                            <FormGroupPreview
                              label='Drop off location'
                              value={booking.dropOffLocation.fullAddress}
                            />
                            <hr />
                            <Row>
                              <Col md='3'>
                                <FormGroupPreview
                                  label='Distance'
                                  value={
                                    getFormattedTripInfo(booking.tripInfo)
                                      .distance
                                  }
                                  addClass='normalizeText'
                                />
                              </Col>
                              <Col md='3'>
                                <FormGroupPreview
                                  label='Time'
                                  value={
                                    getFormattedTripInfo(booking.tripInfo)
                                      .duration
                                  }
                                  addClass='normalizeText'
                                />
                              </Col>
                            </Row>
                          </>
                        )}

                      {booking.type === 'chauffeur_services' &&
                        booking.durationType === 'hourly' && (
                          <>
                            <hr />
                            <FormGroupPreview
                              label='Duration'
                              value={
                                booking.duration == 1
                                  ? `${booking.duration} hour`
                                  : `${booking.duration} hours`
                              }
                              addClass='normalizeText'
                            />
                          </>
                        )}

                      {booking.type === 'chauffeur_services' &&
                        booking.durationType === 'daily' && (
                          <>
                            <hr />
                            <FormGroupPreview
                              label='Duration'
                              value={`${booking.duration.length} days`}
                              addClass='normalizeText'
                            />
                          </>
                        )}
                    </div>
                    <h6 className='price-text'>
                      {' '}
                      {supplier[0].selectedSupplier[0].buyingPrice.toFixed(
                        2
                      )}{' '}
                      {supplier[0].selectedSupplier[0].supplierCurrency
                        .substr(9)
                        .toUpperCase()}{' '}
                    </h6>
                    <SubmitBtn
                      title='Accept this offer'
                      className='accept-btn'
                      onClick={() => {
                        axios
                          .post(
                            process.env.REACT_APP_API_URL +
                              '/api/v1/dispatch/' +
                              bId +
                              '/' +
                              sId
                          )
                          .then(function (response) {
                            if (response.data.meta.success === true) {
                              window.location = `/dispatch/${bId}/${sId}`
                            }
                          })
                          .catch(function (error) {
                            console.log(error)
                          })
                      }}
                    />
                    <h6 className='terms-text'>
                      {' '}
                      By clicking on "Accept this offer", you agree to the
                      booking <span> terms </span>{' '}
                    </h6>
                  </Col>
                </Row>
              </div>
            </div>
          )}
          {!status && (
            <>
              <div className='dispatch-preview-info'>
                <header className='rolzo-header '>
                  <img src='/images/rolzo_logo_black.png' alt='' />
                </header>
              </div>
              <div className='dispatch-msg-modal-expired'>
                <div className='content-wrap'>
                  <Image src={expiredIcon} />
                  <h4 className='dispatch-msg-header'>Booking not found</h4>
                  <p className='dispatch-msg-description'>
                    {'The booking or supplier does not exist.'}
                  </p>
                </div>
              </div>
            </>
          )}
        </div>
      ) : (
        <div> </div>
      )}
    </div>
  )
}

export default DispatchMsg
